<div class="attachments-list-body-show-attachments">
	<rx-attachments
		[isIntuitiveRx]="true"
		[isScanner]="isScanner"
		[rxId]="attachmentsRxId$ | async"
		[companyId]="companyId$ | async"
		[isReadOnly]="isAttachmentsReadOnly$ | async"
		[biSessionInfo]="biSessionInfo$ | async"
		[contactId]="contactId$ | async"
		[userRole]="userRole$ | async"
		[procedureMap$]="procedureMap$"
		[patientGuid$]="patientGuid$"
		[patientName$]="patientName$"
		[featureToggles$]="featureToggles$"
		[companySoftwareOptions$]="companySoftwareOptions$"
		[timberUrl]="timberUrl$ | async"
		(isSafeToClose)="isSafeToClose.emit($event)"
		(attachmentsListUpdated)="attachmentsListUpdated.emit()"
	></rx-attachments>
</div>
